export const REQUEST_USERS_LIST = '@USERS/REQUEST_USERS_LIST'
export const SET_USERS_LIST = '@USERS/SET_USERS_LIST'
export const SET_PAGE = '@USERS/SET_PAGE'
export const REQUEST_DELETE_USER = '@USERS/REQUEST_DELETE_USER'
